import type StateCore from '../state-core'

export default function inline(state: StateCore) {
  const tokens = state.tokens

  // Parse inlines
  for (let i = 0, l = tokens.length; i < l; i++) {
    const tok = tokens[i]
    if (tok.type === 'inline') {
      // oxlint-disable-next-line typescript/no-non-null-assertion -- inline tokens always have children array
      state.md.inline.parse(tok.content, state.md, state.env, tok.children!)
    }
  }
}
